import { DefaultValueConfig } from '@headless-workspace/config';
import { ObjectHelpers } from '@headless-workspace/utils';
import { DataLayerClassName, mapURLToImage } from '../../../../client';
import { HTMLString } from '../../HTMLString';
import { VipBrandsValue } from '../../config';
import { mapTileProduct, TileProductValue } from '../../types';
import { isProductAvailable } from '../../types/ProductStockType';
import { RecommendedProductsDTO, RecommendedTileProductDTO } from './RecommendedProductsDTO';

export type TileProductAvailabilityValue = TileProductValue & {
    isAvailable?: boolean;
};

export enum RecommendationCarouselType {
    T2S = 'T2S',
    POTION = 'POTION',
}

export type RecommendedProductsValue = {
    id: string;
    title: HTMLString;
    carouselType: RecommendationCarouselType;
    cta?: {
        label: string;
        href: string;
    };
    products: TileProductAvailabilityValue[];
};

const mapRecommendedProduct = (
    product: RecommendedTileProductDTO,
    vipBrands: VipBrandsValue,
    originalPriceText?: string,
): TileProductAvailabilityValue => {
    const baseProduct = mapTileProduct(product, vipBrands, originalPriceText);
    const image =
        mapURLToImage(product.imageURL) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder);
    const isAvailable = isProductAvailable(product.stock);

    const dataLayer = {
        id: product.trackingId,
        className: DataLayerClassName.productTile,
    };

    return {
        ...baseProduct,
        image,
        isAvailable,
        dataLayer,
    };
};

export const mapRecommendedProducts = (
    dto: RecommendedProductsDTO[],
    vipBrands: VipBrandsValue,
    originalPriceText?: string,
): RecommendedProductsValue[] => {
    return dto.map((recommendation) => {
        const { cta } = recommendation;
        const ctaData = cta?.label && cta?.link ? { label: cta.label, href: cta.link } : undefined;

        return {
            id: recommendation.id,
            title: HTMLString(recommendation.title ?? ''),
            cta: ctaData,
            carouselType: (recommendation.type as RecommendationCarouselType) ?? RecommendationCarouselType.T2S,
            products: recommendation.products.map((product) =>
                mapRecommendedProduct(product, vipBrands, originalPriceText),
            ),
        };
    });
};
